import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_LAST_UPDATE_DATE } from "../queries/GetProductFamilies";

const fetchLastUpdateDate = async ({ queryKey }) => {
    const [, { token }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const response = await axios.get(
            `/GetLastUpdateDate`,
            {
                headers: {
                    Authorization: token,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetLastUpdateDate = (token) => {
    return useQuery({
        queryKey: [GET_LAST_UPDATE_DATE, { token }],
        queryFn: fetchLastUpdateDate,
        enabled: !!token,
        retry: false,
    });
};
